/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Link } from "react-router-dom";

function Menus({ varMenuType, varMenuItem }) {
  //로그인뮤우
  //const adminLoginState = Number(localStorage.getItem('adminLoginState'));
  const adminMode = Number(localStorage.getItem("adminMode"));

  if (varMenuType === "ENVIRONMENT") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div id="gnbs">
          <ul className="depth1">
            {/* 운영정보관리 */}
            <li
              className={
                varMenuItem === "AdminInformation" ||
                varMenuItem === "Variables" ||
                varMenuItem === "Service" ||
                varMenuItem === "Privacy"
                  ? "selectedmenu"
                  : ""
              }
            >
              <a>설정 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/Variables"}>
                    <span
                      className={
                        varMenuItem === "Variables" ? "selectedlimenu" : ""
                      }
                    >
                      - 카테고리 관리
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerms/1"}>
                    <span
                      className={
                        varMenuItem === "Service" ? "selectedlimenu" : ""
                      }
                    >
                      - 이용약관 관리
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/AdminTerms/2"}>
                    <span
                      className={
                        varMenuItem === "Privacy" ? "selectedlimenu" : ""
                      }
                    >
                      - 개인정보처리방침 관리
                    </span>
                  </Link>
                </li>
                {adminMode === 3 ? (
                  <li className="m03">
                    <Link to={"/Admin/AdminInformation"}>
                      <span
                        className={
                          varMenuItem === "AdminInformation"
                            ? "selectedlimenu"
                            : ""
                        }
                      >
                        - 관리자 정보 관리
                      </span>
                    </Link>
                  </li>
                ) : null}
              </ul>
            </li>
            {/* 업체 정보 관리 */}
            <li className={varMenuItem === "CompanyInfo" ? "selectedmenu" : ""}>
              <a>운영 정보 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/CompanyInfo"}>
                    <span
                      className={
                        varMenuItem === "CompanyInfo" ? "selectedlimenu" : ""
                      }
                    >
                      - 업체 정보 관리
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
    /* 직원관리 */
  } else if (varMenuType === "MEMBER") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div id="gnbs">
          <ul className="depth1">
            <li
              className={
                varMenuItem === "StaffList" ||
                varMenuItem === "StaffWorkingList" ||
                varMenuItem === "StaffCallNetworkList"
                  ? "selectedmenu"
                  : ""
              }
            >
              <a>직원 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/StaffList"}>
                    <span
                      className={
                        varMenuItem === "StaffList" ? "selectedlimenu" : ""
                      }
                    >
                      - 직원 현황
                    </span>
                  </Link>
                </li>
                {/* <li className="m03">
                  <Link to={"/Admin/StaffWorkingList"}>
                    <span className={varMenuItem === "StaffWorkingList" ? "selectedlimenu" : ""}>- 근태 관리</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/StaffReportList"}>
                    <span className={varMenuItem === "StaffReportList" ? "selectedlimenu" : ""}>- 업무일자 관리</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/StaffAnnualList"}>
                    <span className={varMenuItem === "StaffAnnualList" ? "selectedlimenu" : ""}>- 연차 관리</span>
                  </Link>
                </li> */}
                <li className="m03">
                  <Link to={"/Admin/ExpireStaffList"}>
                    <span
                      className={
                        varMenuItem === "ExpireStaffList"
                          ? "selectedlimenu"
                          : ""
                      }
                    >
                      - 탈퇴 직원 관리
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/StaffCallNetworkList"}>
                    <span
                      className={
                        varMenuItem === "StaffCallNetworkList"
                          ? "selectedlimenu"
                          : ""
                      }
                    >
                      - 직원 연락망 관리
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
    /* 배차관리 */
  } else if (varMenuType === "DELIVERY") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div id="gnbs">
          <ul className="depth1">
            {/* 배차관리 */}
            <li
              className={
                varMenuItem === "DeliveryList" ||
                varMenuItem === "SalesList" ||
                varMenuItem === "CustomerList"
                  ? "selectedmenu"
                  : ""
              }
            >
              <a>배차 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/DeliveryList"}>
                    <span
                      className={
                        varMenuItem === "DeliveryList" ? "selectedlimenu" : ""
                      }
                    >
                      - 배차현황
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/SalesList"}>
                    <span
                      className={
                        varMenuItem === "SalesList" ? "selectedlimenu" : ""
                      }
                    >
                      - 매출현황
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/CustomerList"}>
                    <span
                      className={
                        varMenuItem === "CustomerList" ? "selectedlimenu" : ""
                      }
                    >
                      - 거래처 관리
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
    /* 기사관리 */
  } else if (varMenuType === "DRIVER") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div id="gnbs">
          <ul className="depth1">
            {/* 기사관리 */}
            <li
              className={
                varMenuItem === "DriverList" ||
                varMenuItem === "ExpiredDriverList"
                  ? "selectedmenu"
                  : ""
              }
            >
              <a>기사 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/DriverList/1"}>
                    <span
                      className={
                        varMenuItem === "DriverList" ? "selectedlimenu" : ""
                      }
                    >
                      - 기사현황
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/DriverList/0"}>
                    <span
                      className={
                        varMenuItem === "ExpiredDriverList"
                          ? "selectedlimenu"
                          : ""
                      }
                    >
                      - 탈퇴기사현황
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
    /* 게시판 관리 */
  } else if (varMenuType === "BOARDS") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div id="gnbs">
          <ul className="depth1">
            <li
              className={
                varMenuItem === "NoticeList" || varMenuItem === "QuestionList"
                  ? "selectedmenu"
                  : ""
              }
            >
              <a>게시글 관리</a>
              <ul className="depth2">
                <li className="m03">
                  <Link to={"/Admin/Boards/NoticeList"}>
                    <span
                      className={
                        varMenuItem === "NoticeList" ? "selectedlimenu" : ""
                      }
                    >
                      - 공지사항 관리
                    </span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/Boards/QuestionList"}>
                    <span
                      className={
                        varMenuItem === "QuestionList" ? "selectedlimenu" : ""
                      }
                    >
                      - 1:1문의 관리
                    </span>
                  </Link>
                </li>
                {/* <li className="m03">
                  <Link to={"/Admin/Boards/SuggestionList"}>
                    <span className={varMenuItem === "SuggestionList" ? "selectedlimenu" : ""}>- 건의 관리</span>
                  </Link>
                </li>
                <li className="m03">
                  <Link to={"/Admin/Boards/ReferenceRoomList"}>
                    <span className={varMenuItem === "ReferenceRoomList" ? "selectedlimenu" : ""}>- 자료실 관리</span>
                  </Link>
                </li> */}
              </ul>
            </li>
          </ul>
        </div>
      </div>
    );
  } else if (varMenuType === "") {
    return (
      <div id="left-wraps">
        <div className="logo">
          <p className="h1">더나은물류관리시스템</p>
        </div>
        <div
          id="gnbs"
          style={{ height: "calc(100vh - 101px)", overflow: "hidden" }}
        ></div>
      </div>
    );
  }
}

export default Menus;
